export default __webpack_public_path__ + "static/media/torus.c33c813a.png";